export default "__VITE_PUBLIC_ASSET__28981957__"